import { useState, useEffect } from 'react';
import { rmmAPI } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Loader2 } from 'lucide-react';
import { fmtWhen } from './rmmUtils';

export const AuditTab = () => {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    rmmAPI.auditLogs(200).then((res) => setLogs(res.data)).catch(() => setLogs([]));
  }, []);

  if (!logs) return <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-cyan-500" /></div>;

  return (
    <Card className="bg-white border-slate-200" data-testid="rmm-audit-tab">
      <CardContent className="p-4 space-y-2">
        {logs.length === 0 && <p className="text-sm text-slate-400 py-4 text-center">No RMM audit entries yet.</p>}
        {logs.map((l) => (
          <div key={l.id} className="flex items-center justify-between p-2.5 rounded-lg border border-slate-200 gap-3">
            <div className="min-w-0">
              <p className="text-sm text-slate-800">
                <span className="font-medium">{l.actor_name || 'System / Agent'}</span>
                <span className="text-slate-500"> — {(l.action || '').replaceAll('_', ' ')}</span>
                <span className="text-slate-400"> · {l.entity_type}</span>
              </p>
              <p className="text-xs text-slate-400 truncate">{l.details}{l.ip ? ` · ${l.ip}` : ''} · {fmtWhen(l.created_at)}</p>
            </div>
            <Badge className={l.success !== false ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}>
              {l.success !== false ? 'success' : 'failed'}
            </Badge>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
